import { Panel } from 'components/ideal-core-ui'
import s from './AboutInfo.scss'

const AboutInfo = ({ about }) => (
  <Panel
    title="A few things about this contact"
    innerStyles={{ minHeight: 'auto' }}
    panelStyles={{ marginTop: 24 }}
    hasInnerPadding
  >
    <div className={s.about}>{about || 'No information yet.'}</div>
  </Panel>
)

export default AboutInfo
